
import jwtDecode from "jwt-decode";
export default function ErrorHandler(error){
    const user = localStorage.getItem('userData')?jwtDecode(JSON.parse(localStorage.getItem('userData')).token): {};
    console.error(error,` User Id: ${user.user_id}`)
}